import Base from "../../../common/models/base";
import TintOverlayView from "../../../google_maps/tint_overlay_view"

export default class Map extends Base {
  static {
    this.delegate("controls", "zoom", {to() { return this.gMap; }});
  }

  constructor(options = {}) {
    super(options);
    const lat = parseFloat(options.lat);
    const lng = parseFloat(options.lng);
    const zoom = parseInt(options.zoom);
    const center = { lat, lng };

    this.gMap = new google.maps.Map(
      options.element,
      {
        zoom,
        center,
        mapTypeId: options.mapType,
        mapTypeControl: false,
        rotateControl: false,
        streetViewControl: false
      }
    );
    this.gMap.setTilt(0);

    const tintOverlay = new TintOverlayView();
    tintOverlay.setMap(this.gMap);
  }
}
